/**
 * created by li si yi
 * 流程中心-待我处理
 */
import React, {Component} from 'react';
import {Input, message, Tabs, Pagination, Modal, Tree, Icon} from "antd";
import PropTypes from "prop-types";
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import MyIconSvg from "../messageCenter/svg"
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import {getInfoFromLocalStorage} from "../../../actions";
import ProcessToDo from '../../newDesktop/components/config/ProcessToDo'

const {TabPane} = Tabs;
const {Search} = Input;
const {TreeNode} = Tree;

export default class ProcessCenterUntreated extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            // 选项卡数据
            tabBarList: [
                {
                    key: '0',
                    name: '待我处理',
                    status: '0',
                    url: "/cm-sites-sys/process/getTodoList",
                },
                {
                    key: '1',
                    name: '我已处理',
                    status: '1',
                    url: "/cm-sites-sys/process/getMyFinished",
                },
                {
                    key: '2',
                    name: '我发起的',
                    status: '2',
                    url: "/cm-sites-sys/process/getMyInitList",
                }
            ],
            columns: [
                {
                    title: '类型',
                    dataIndex: 'activitiCategoryName',
                    key: 'activitiCategoryName',
                    width: '150px',
                    render: (text, record) => {
                        let icon = this.itemTodoIcon(record) || "toDoListDefault";
                        return (
                            <div style={{display: 'flex'}} title={text}>
                                <MyIconSvg type={icon} style={{size: 24, alignSelf: 'center'}}
                                           colors={["rgb(220, 244, 236)", "rgb(40, 174, 126)"]}/>
                                <div style={{
                                    marginLeft: '8px',
                                    width: 100,
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                }}>{text}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '标题',
                    dataIndex: 'title',
                    ellipsis: true,
                    key: 'title',
                    width: 400,
                    render: (text, record) => {
                        return (
                            <span onClick={() => {
                                this.itemTodoClick(record);
                                // this.showMessageVisible = true;
                            }} style={{
                                cursor: 'pointer',
                                lineHeight: '24px'
                            }}>{record.data && record.data.applyReason && record.activitiCategoryKey === 'zyxzsq' ? record.data.applyReason : text}</span>
                        )
                    }
                },
                {
                    title: '提交时间',
                    dataIndex: 'updateTime',
                    key: 'updateTime',
                    ellipsis: true,
                    width: 200,
                    render: (text) => {
                        let startTime = moment(text).format('YYYY-MM-DD') + " " + moment(text).format('LTS');
                        return (
                            <div style={{lineHeight: '24px'}}>
                                {startTime}
                            </div>
                        )
                    }
                },
                {
                    title: '提交人',
                    dataIndex: 'createUserName',
                    key: 'createUserName',
                    width: 200,
                    ellipsis: true,
                    render: (text, record) => {
                        let userInfo = getInfoFromLocalStorage("currentUser");
                        let userName = '';
                        // 待我处理时（0）取提交的人，我已处理时（1）取最后一次提交的人,我发起的（2）取创建人
                        if (this.state.thisTabKey === '0') {
                            userName = record.operatorUserName ? record.operatorUserName : '';
                        } else if (this.state.thisTabKey === '1') {
                            let arr = record.historyInfo ? record.historyInfo : [];
                            // console.log('record.historyInfo.reverse()', record.historyInfo)
                            let num = [];
                            arr.forEach((item, index) => {
                                if (item.operatorUser == userInfo.id && item?.operatorUserInfo?.deptId == userInfo?.defaultInfo?.dept?.id) {
                                    num.push(index);
                                }
                            });
                            arr.forEach(() => {
                                if (arr && arr.length > 1) {
                                    userName = arr[num[num.length - 1] - 1].operatorUserName;
                                }
                            })
                        } else if (this.state.thisTabKey === '2') {
                            userName = text;
                        }
                        return (
                            <span style={{lineHeight: '24px'}}>{userName}</span>
                        )
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'taskName',
                    ellipsis: true,
                    width: 200,
                    render: (text) => {
                        let color;
                        if (text === '已发布' || text === '发布' || text === '通过') {
                            color = "#87D166";
                        } else if (text === '已弃用' || text === '已返回' || text === '不通过') {
                            color = "#F56C6C";
                        } else {
                            color = "#CC77FF";
                        }
                        return (
                            <div style={{display: 'flex'}}>
                                <div style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    background: `${color}`,
                                    alignSelf: 'center',
                                    marginRight: '5px',
                                    lineHeight: '24px'
                                }}/>
                                <div title={text ? text : ''} style={{
                                    width: 150,
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                }}>{text ? text : ''}</div>
                            </div>
                        )
                    }
                },
            ],
            thisTabKey: '0',// 选项卡当前选中项
            params: {
                page: {
                    start: 1,//分页
                    size: 10,
                },
                activitiCategoryKeys: [],//默认
                operatorUser: '',// 当前用户
                title: "",// 搜索
                showData: true
            },
            total: 0,
            dataSource: [],//表格数据
            treeData: [],// 树类型数据
            selectedKeys: [],// 选中
            visible: false, // 弹框
            modalContent: {},// 弹框内容
            statisticsParams: {// 左侧树统计
                userId: window.currentUser.id,
                deptId: window.currentUser.deptIds[0],
                selectType: 1
            },
            allStatistics: 0,// 总数
        };
    }

    componentWillMount() {
        let account = getInfoFromLocalStorage("currentUser").id;
        this.state.params.operatorUser = account;
        this.state.selectedKeys = ['activiti_root'];
        this.getTreeStatistics();
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    // 获取待办树分类数据
    getTree = (treeStatisticsData) => {
        this.request({
            url: '/cm-sites-sys/activitiCategory/getTree',
            contentType: "json",
            callBack: (res) => {
                let treeData = [];
                let allStatistics = 0;
                if (res) {
                    treeData = res.sons;
                    for (let key in treeStatisticsData) {
                        treeData && treeData.map(Item => {
                            if (key === Item.key) {
                                Item.total = treeStatisticsData[key];
                            }
                            if (key === "total") {
                                allStatistics = treeStatisticsData[key]
                            }
                        })
                    }
                }
                this.setState({
                    treeData, allStatistics
                });
                this.getData();
            },
            errorCallBack: (e) => {
            }
        })
    };
    // 获取待办树分类数据
    getTreeStatistics = () => {
        let {statisticsParams} = this.state;
        this.request({
            url: '/cm-sites-sys/process/statistics',
            body: statisticsParams,
            callBack: (res) => {
                let treeStatisticsData = {};
                if (res) {
                    treeStatisticsData = res;
                }
                this.getTree(treeStatisticsData);
                // this.setState({treeStatisticsData});
            },
            errorCallBack: (e) => {
            }
        })
    };
    // 获取表数据
    getData = () => {
        let {params, tabBarList, thisTabKey} = this.state;
        let thisTabBar = tabBarList.find(item => item.key === thisTabKey);
        let url = thisTabBar && thisTabBar['url'] || "";
        if (!url) return false;
        this.request({
            url: url,
            method: "post",
            body: params,
            contentType: "json",
            callBack: (res) => {
                let dataSource = [];
                let total = 0;
                if (res) {
                    dataSource = res.data;
                    total = res.count;
                }
                this.setState({dataSource, total})
            },
            errorCallBack: (e) => {
            }
        })
    };

    render() {
        return (
            <div className="card-container"
                 style={{marginTop: '15px', display: 'flex', justifyContent: 'center', height: 'calc(100vh - 100px)'}}>
                {/*左侧结构*/}
                {this.renderTree()}
                <div style={{background: '#fff', borderRadius: '5px', width: 1380}}>
                    {/*选项卡*/}
                    {this.renderTabBar()}
                    {/*搜索*/}
                    {this.renderSearch()}
                    {/*内容*/}
                    {this.renderTable()}
                    {/*消息弹框*/}
                    {this.renderModal()}
                    <ProcessToDo ref={(ProcessToDo) => {
                        this.ProcessToDo = ProcessToDo
                    }} refresh={() => {
                        this.getData()
                    }}/>
                </div>
            </div>
        )
    }

    // 左侧栏
    renderTree = () => {
        let {treeData, selectedKeys} = this.state;
        return (
            <div style={{
                background: '#fff',
                borderRadius: '5px',
                borderRight: '1px solid rgb(208, 223, 241)',
                width: 260
            }}>
                <div style={{fontSize: '20px', textAlign: 'left', color: '#222', padding: '12px 0px 5px 24px'}}>流程中心
                </div>
                <div className={'processCenterTree'}>
                    <Tree
                        showIcon
                        onSelect={this.onSelectTree}
                        selectedKeys={selectedKeys}
                        // defaultCheckedKeys={[0]}
                    >
                        <TreeNode key={'activiti_root'} title={
                            <div style={{display: 'flex'}}>
                                <div style={{
                                    width: 20,
                                    height: 20,
                                    alignSelf: 'center',
                                    marginRight: '5px'
                                }}>
                                    <MyIconSvg
                                        colors={[selectedKeys.toString() === 'activiti_root' ? this.themeBgColor : 'rgba(0, 0, 0, 0.65)']}
                                        type={'processAll'} style={{size: 20}}/>
                                </div>
                                <div
                                    style={{color: [selectedKeys.toString() === 'activiti_root' ? this.themeBgColor : ""]}}>全部<span
                                    style={{color: '#F56C6C'}}>{"（" + this.state.allStatistics + "）"}</span>
                                </div>
                            </div>
                        }>
                        </TreeNode>
                        {
                            treeData.map((item, index) => {
                                let treeIcon;
                                switch (item.name) {
                                    case '稿件':
                                        treeIcon = 'menuIconGJ';
                                        break;
                                    case '约稿':
                                        treeIcon = 'menuIconCF';
                                        break;
                                    case '采访':
                                        treeIcon = 'menuIconYG';
                                        break;
                                    case '线索':
                                        treeIcon = 'menuIconXS';
                                        break;
                                    case '选题':
                                        treeIcon = 'menuIconXT';
                                        break;
                                    case '资源下载申请':
                                        treeIcon = 'menuIconZYXZ';
                                        break;
                                    case '媒体备案申请':
                                        treeIcon = 'menuIconMTBA';
                                        break;
                                    default:
                                        treeIcon = "processCenterDefault";
                                        break
                                }
                                return (
                                    <TreeNode title={
                                        <div style={{display: 'flex'}}>
                                            <div style={{
                                                width: 20,
                                                height: 20,
                                                alignSelf: 'center',
                                                marginRight: '5px'
                                            }}>
                                                <MyIconSvg
                                                    colors={[item.key == selectedKeys.toString() ? this.themeBgColor : 'rgba(0, 0, 0, 0.65)']}
                                                    type={treeIcon} style={{size: 20}}/>
                                            </div>
                                            <div
                                                style={{color: [item.key == selectedKeys.toString() ? this.themeBgColor : ""]}}>{item.name}<span
                                                style={{color: '#F56C6C'}}>{"（" + item.total + "）"}</span>
                                            </div>
                                        </div>
                                    } key={item.key} style={{
                                        width: '260px',
                                        color: item.key == selectedKeys.toString() ? "#0050B3" : "#f00",
                                    }}>
                                    </TreeNode>
                                )
                            })
                        }
                    </Tree>
                    <style>
                        {`
                        .processCenterTree .ant-tree .ant-tree-treenode-switcher-close{
                            font-size:font-weight: 400;
                            font-size: 16px;
                            text-align: left;
                            color: rgba(0, 0, 0, 0.65);
                            background:none;
                            padding:0;
                        }
                        .processCenterTree .ant-tree .ant-tree-treenode-switcher-close:hover{
                            background:#f6f8fd;
                            cursor:pointer;
                        }
                        .processCenterTree .ant-tree .ant-tree li .ant-tree-node-content-wrapper:hover{
                            background-color:none;
                            color:none;
                        }
                        .processCenterTree .ant-tree li .ant-tree-node-content-wrapper{
                                padding:0;
                                padding:7px 0 4px 24px;
                                width:100%;
                                height:100%;
                                color:none;
                         }
                        .processCenterTree .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected{
                            background-color:#f6f8fd !important;
                            width:100%;
                            color:none;
                        }
                        .processCenterTree .ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop{
                           display:none;
                        }
                        `}
                    </style>
                </div>
            </div>
        )
    };
    // 选项卡
    renderTabBar = () => {
        return (
            <div className={'tabBarStyle'}>
                <Tabs defaultActiveKey="0" onChange={this.changeTabBar}>
                    {
                        this.state.tabBarList.map((item) => {
                            return (
                                <TabPane tab={item.name} key={item.key}
                                         style={{backgroundColor: '#fff', color: '#0050B3'}}/>
                            )
                        })
                    }
                </Tabs>
                <style>
                    {`
                        .tabBarStyle .ant-tabs-nav{
                             padding-left: 16px;
                             padding-top:5px;
                         }
                    `}
                </style>
            </div>
        )
    };
    // 搜索
    renderSearch = () => {
        return (
            <Search
                placeholder="请输入关键词"
                ref='searchBar'
                allowClear
                onSearch={(value) => {
                    this.searchChange(value)
                }}
                style={{width: 224, height: '32', margin: '24px 32px'}}
            />
        )
    };
    // 内容部分
    renderTable = () => {
        let {dataSource, columns} = this.state;
        return (
            <>
                <div style={{height: "calc(100vh - 340px)", padding: '0 32px'}} className={'processCenter'}>
                    <Scrollbars autoHide autoHeightMax={600}>
                        <BaseTable rowKey="id" dataSource={dataSource}
                                   columns={columns}
                                   pagination={false}/>
                    </Scrollbars>
                    {/*分页*/}
                    <style>{`
                    .processCenter .ant-table-placeholder{
                       display:flex;
                       justify-content: center;
                       align-items: center;
                       height:545px;
                       border:none;
                    }
                    .processCenter .ant-table-body{
                       border:1px solid #fff;
                    }
                `}</style>
                </div>
                {this.state.dataSource.length ? this.renderFooter() : null}
            </>
        )
    };
    // 分页
    renderFooter = () => {
        let {params, total} = this.state;
        let {start, size} = params.page;
        return (
            <div className={'pagination'} style={{marginTop: 20}}>
                <div style={{marginRight: '5px'}}>共 {total} 条</div>
                <Pagination
                    showSizeChanger
                    current={start}
                    pageSize={size}
                    total={total}
                    showQuickJumper={true}
                    onChange={this.pageChange}
                    onShowSizeChange={this.pageChange}
                />
            </div>
        )
    };
    //子弹窗
    renderModal = () => {
        let {modalContent, visible} = this.state;
        let text = modalContent.data && modalContent.data.title || "";
        return (
            <div className={'modalStyle'}>
                <Modal
                    title="消息提醒"
                    visible={visible}
                    onOk={this.hideModal}
                    onCancel={this.hideModal}
                    centered={true}
                    okText="查看"
                    cancelText="取消"
                >
                    <div style={{height: 80}}>{text}</div>
                </Modal>
            </div>
        )
    };
    // 分页改变
    pageChange = (start, size) => {
        console.log(start, size);
        let {page} = this.state.params;
        // 获取当前tab参数
        page.start = start;
        page.size = size;
        this.getData();
    };
    // 选项卡改变
    changeTabBar = (key, e) => {
        if (key === "0") {
            this.state.statisticsParams.selectType = 1
        } else if (key === "1") {
            this.state.statisticsParams.selectType = 2
        } else if (key === "2") {
            this.state.statisticsParams.selectType = 3
        }
        this.state.thisTabKey = key;
        this.state.params.page.start = 1;
        this.state.params.title = "";
        this.setState({}, () => {
            this.getData();
            this.getTreeStatistics();
            this.reset();
        })
    };
    // 左侧栏当前选择
    onSelectTree = (selectedKeys, {selected, selectedNodes, node, event}) => {
        if (!selected) return;
        let {params} = this.state;
        this.state.selectedKeys = selectedKeys;
        this.state.params.page.start = 1;
        selectedKeys = selectedKeys.toString();
        if (selectedKeys.toString() === 'story' || "") {
            params.activitiCategoryKeys = ['article'];
        } else if (selectedKeys.toString() === 'activiti_root') {
            params.activitiCategoryKeys = [];
        } else {
            params.activitiCategoryKeys = this.state.selectedKeys;
        }
        this.state.params.title = "";
        this.getData();
        this.reset();
    };
    // 搜索
    searchChange = (value) => {
        let {params} = this.state;
        this.state.params.page.start = 1;
        params.title = value;
        this.getData();
    };
    // 清空搜索框
    reset = () => {
        this.refs.searchBar.input.state.value = "";
    };
    // 弹框
    showModal = () => {
        this.setState({
            visible: true,
        });
    };
    hideModal = () => {
        this.setState({
            visible: false,
        });
    };

    itemTodoClick(item) {
        this.ProcessToDo.getTodoList(item);
    }
    // 点击执行当前方法
    itemTodoIcon(item) {
        let icon = this.ProcessToDo.getTodoListIcon(item);
        return icon
    }
};

ProcessCenterUntreated.defaultProps = {};
ProcessCenterUntreated.propTypes = {};